/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStatesEnum } from './subscriptionStatesEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { SubscriptionResponse } from './subscriptionResponse';
import { OfferRegionEnum } from './offerRegionEnum';
import { DataCentersEnum } from './dataCentersEnum';
import { SubscriptionTypeEnum } from './subscriptionTypeEnum';


export interface Subscription { 
    org_id?: string;
    service_type?: ServiceTypeEnum;
    subscription_id?: string;
    state?: SubscriptionStatesEnum;
    data_center?: DataCentersEnum;
    offer_region?: OfferRegionEnum;
    subscription_type?: SubscriptionTypeEnum;
    start_date?: Date;
    request_date?: Date;
    activation_request_date?: Date;
    activation_requested?: boolean;
    cancellation_requested?: boolean;
    created_by?: string;
    migrated?: boolean;
    migrated_by?: string;
    task_id?: string;
    subscription_response?: SubscriptionResponse;
}
export namespace Subscription {
}


